/**
 * 封装 请求
 */
import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '@/store'

const server = axios.create({
  baseURL: process.env.VUE_APP_BASE_API + process.env.VUE_APP_API_VERSION,
  timeout: 50000
})

// 请求拦截器
server.interceptors.request.use(
  config => {
    // 在这个位置上统一注入 token
    if (store.getters.token) {
      config.headers.token = `${store.getters.token}`
    }
    return config
  }
)

// 响应拦截器
server.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error?.response?.data?.error_code === 20002) {
      // 登录状态失效
      ElMessage.error(error.response.data.message)
      store.dispatch('admin/logout')
    } else if (error?.response?.data?.error_code === 20001) {
      // 账号冻结
      ElMessage.error(error.response.data.message)
      store.dispatch('admin/logout')
    } else if (error.response && error.response.data && error.response.data.error_code === 20000) {
      // 没有权限
      return error.response.data
    } else if (error.response && error.response.data && error.response.data.error_code === 40000) {
      // 空数据
      return error.response.data
    } else if (error.response && error.response.data && error.response.data.error_code === 10000) {
      // 逻辑异常
      return error.response.data
    } else if (error.response && error.response.data && error.response.data.error_code === 30000) {
      // 参数异常
      return error.response.data
    } else {
      // 长流程需要结合当前节点生成更可读的错误，可以显式关闭全局通用 toast。
      // 错误仍会 reject，不会被吞掉；由调用页面负责呈现和节点状态。
      if (!error?.config?.suppressErrorToast) ElMessage.error(error.message)
    }
    return Promise.reject(error)
  }
)

export default server
